<!-- Cargo Application Root -->
<!-- Один router-outlet на месте: при смене каркаса (сайт / личный кабинет) страница не пересоздаётся -->
<div class="app-main" [class.app-main--platform]="platformLayout">
  @if (platformLayout) {
    <app-platform-shell />
  } @else {
    <app-header />
  }
  <main class="app-content">
    <router-outlet />
  </main>
</div>
@if (!platformLayout) {
  <app-footer />
}
<app-phone-claim-modal />
<app-confirm-dialog />
<app-impersonation-banner />
